import { FormControlLabel, Radio, RadioGroup as RadioGroupInput } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { OrderReviewContext } from '../../../../QaOrderReview/OrderReviewContext';
import { getAnswerImages, removeChildAnswers } from '../../FormDefinitionInput.utils';
import styles from './RadioGroup.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  checkIfAnswerTriggersNewFormHeader: PropTypes.func.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  imageToEdit: PropTypes.object,
  removeAnswers: PropTypes.func.isRequired,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const RadioGroup = ({
  classes,
  checkIfAnswerTriggersNewFormHeader,
  formDefinition,
  isReadOnly,
  imageToEdit,
  removeAnswers,
  saveAnswers,
  updateFormHeaders,
}) => {
  const { dispatch: orderReviewDispatch } = useContext(OrderReviewContext);
  const saveAnswersDebounceHandler = useCallback(
    debounce(newAnswers => {
      saveAnswers(newAnswers);
    }, 750),
    [],
  );

  const getInitialValueId = () =>
    formDefinition.answers.length !== 0 && formDefinition.answers[0].valueId !== null
      ? formDefinition.answers[0].valueId.toString()
      : '';

  const handleOnChange = async event => {
    const eventAnswerTrigger = formDefinition.answerTriggers.find(
      at => at.answerValueId.toString() === event.target?.value.toString(),
    );
    const eventAnswerValue = eventAnswerTrigger ? eventAnswerTrigger.answerValue : null;
    let newAnswers = [];
    let answerImages = getAnswerImages(formDefinition, imageToEdit);

    if (!formDefinition.answers.find(answer => answer.valueId === event.target.value)) {
      newAnswers = [
        {
          orderFormHeaderId: formDefinition.orderFormHeaderId,
          formDefinitionId: formDefinition.formDefinitionId,
          questionId: formDefinition.questionId,
          formQaAnswerId: formDefinition.answers.length !== 0 ? formDefinition.answers[0].formQaAnswerId : null,
          type: formDefinition.answerType,
          valueId: event.target.value,
          value: eventAnswerValue,
          text: null,
          modifiedOn: new Date(),
          images: answerImages,
          default: formDefinition.answers.length !== 0 ? formDefinition.answers[0].default : null,
        },
      ];
    }
    removeChildAnswers(formDefinition, event.target.value, false, orderReviewDispatch, removeAnswers);
    updateFormHeaders(newAnswers);
    if (newAnswers.length === 0) {
      removeAnswers(formDefinition.answers);
    } else {
      saveAnswersDebounceHandler(newAnswers);
    }
    checkIfAnswerTriggersNewFormHeader(event.target.value);
  };

  return (
    <RadioGroupInput
      aria-label={formDefinition.questionValue}
      name={formDefinition.questionValue}
      className={classes.radioGroup}
      value={getInitialValueId()}
      onChange={handleOnChange}
    >
      {formDefinition.answerTriggers.map(at => (
        <FormControlLabel
          key={at.answerValueId}
          value={at.answerValueId.toString()}
          control={<Radio />}
          label={at.answerValue}
          disabled={isReadOnly}
        />
      ))}
    </RadioGroupInput>
  );
};

RadioGroup.propTypes = propTypes;
export default withStyles(styles)(RadioGroup);
